module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', {
      key: index,
      class: [_vm.isStock ? ("star" + (data.star)) : (data.star > 2 ? 'important' : '')]
    }, [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(data.time_show))]), _vm._v(" "), _c('td', {
      staticClass: "ushk-table_rowspan ushk-rili_content-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/" + (data.country) + ".png"),
        "width": "24",
        "height": "16",
        "border": "0"
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "ushk-table_alignLeft"
    }, [_vm._v("\n                    " + _vm._s(data.title) + "\n                    ")])]), _vm._v(" "), _c('td', [_c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('td', [(data.revised) ? _c('div', {
      staticClass: "ushk-rili_content-previous"
    }, [_vm._v("\n                " + _vm._s(data.revised) + "\n                "), _c('span', [_vm._v("修正前"), _c('br'), _vm._v(" "), (data.previous !== null && data.previous !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]], 2)]) : [(data.previous !== null && data.previous !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]]], 2), _vm._v(" "), _c('td', [(data.consensus !== null && data.consensus !== '') ? [_vm._v("\n                  " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.consensus) + _vm._s(data.unit === '%' ? data.unit : '') + "\n              ")] : [_vm._v("\n                ---\n              ")]], 2), _vm._v(" "), _c('td', [_c('div', {
      attrs: {
        "id": data.id
      }
    }, [(data.actual !== null && data.actual !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.actual) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                  ")] : [_vm._v("\n                    未公布\n                  ")]], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "id": ("J_" + (data.id))
      }
    }, [(data.show_affect && data.country !== '中国') ? _c('div', {
      staticClass: "ushk-tag_trend"
    }, [_c('p', {
      class: data.status_class ? data.status_class : 'default'
    }, [_c('span', {
      staticClass: "ushk-btn J_kind_tag",
      attrs: {
        "data-trend": "1"
      }
    }, [(data.status_name === '未公布') ? _c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v("---")]) : [_c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('i', {
      staticClass: "J_kind_trendType"
    }, [_vm._v(_vm._s(data.status_name === '影响较小' ? ' ' : '股票') + " ")])]], 2)])]) : _vm._e()])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.noneText))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0e1dcc","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/EconomicsList.vue
// module id = YC7w
// module chunks = 3